var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAcceptIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 53,
    viewBox: "0 0 54 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.7125 0.251369C29.69 14.0836 22.1465 22.7777 18.1275 25.3958C14.9392 38.9115 19.8259 48.958 22.6677 52.2918H43.3512C48.638 52.4726 49.2199 47.5454 48.8499 45.0593C51.9978 44.4716 51.5741 39.6914 50.9687 37.3747C54.8027 36.0638 53.4742 31.6678 52.3308 29.6336L53.8946 25.3958C55.3475 18.7056 41.5855 18.9919 34.5229 19.9713C37.9129 1.39275 31.3951 -0.916385 27.7125 0.251369Z",
    fill: "#679353"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6223 52.3007C8.7782 44.9176 12.4697 31.7922 15.546 26.1523H1.69765C-1.99388 29.8439 1.18493 45.1227 3.23578 52.3007H18.6223Z",
    fill: "#679353"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcceptIcon);
export default __webpack_public_path__ + "static/media/acceptIcon.93eaf36e76bb0706f1bce250c2dd5331.svg";
export { ForwardRef as ReactComponent };